import React from 'react';

import { CurrencyIcon } from '@pkg/components';
import { type BaseCurrencyType } from '@pkg/types';

import { CurrencyIconCircle, CurrencyPrice, CurrencyPriceValue, PriceBase, UsdPrice } from './styles';

interface PriceProps {
    currency: BaseCurrencyType;
    currencyPrice: number;
    usdPrice: number;
}

export const Price = ({ currency, currencyPrice, usdPrice }: PriceProps) => {
    return (
        <PriceBase>
            <UsdPrice>${usdPrice}</UsdPrice>
            <CurrencyPrice>
                <CurrencyIconCircle>
                    <CurrencyIcon currency={currency} />
                </CurrencyIconCircle>
                <CurrencyPriceValue>{currencyPrice}</CurrencyPriceValue>
            </CurrencyPrice>
        </PriceBase>
    );
};
